var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center mt-5"},[_c('h2',[_c('v-icon',{staticClass:"text-h4 acomplishment-icon"},[_vm._v(" mdi-medal ")])],1),_c('p',{staticClass:"text-h6"},[_vm._v(_vm._s(_vm.success)+"/"+_vm._s(_vm.total))])])}
var staticRenderFns = []

export { render, staticRenderFns }